import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { ReturnLossMutationKeys } from '../../../keys'
import {
	UpdateReturnLossRequest,
	UpdateReturnLossResponse,
} from '../../../type'
import { updateReturnLoss } from '../../services'

interface UpdateReturnLossParams {
	id: string
	payload: UpdateReturnLossRequest
}

export default function useMutationUpdateReturnLoss(
	props?: UseBaseMutationOptions<
		UpdateReturnLossResponse,
		UpdateReturnLossParams
	>,
) {
	return useMutation({
		mutationKey: [ReturnLossMutationKeys.UpdateReturnLoss],
		mutationFn: (params) => updateReturnLoss(params.id, params.payload),
		...props,
	})
}
